module.exports = __webpack_public_path__ + "static/media/kcs.6f08f2b0.svg";